import axios from '@/plugins/axios'
import {Message, MessageBox} from 'element-ui'

export default {
  namespaced: true,

  state: {
    loading: false,
    data: [],
    artists: [],
    dialog_track: false,
    dialog_artist: false,
    dialog_artist_id: null,
    dialog_artist_type: '',
    dialog_upload: false,
    upload_image: null,
    track: {},
    moods: [],
    genres: [],
    restrictions: [],
    socials: [],
    pricing:[],
    image: null,
    download_track: null,
    countries: [],
    countryModal: false,
    ddex_step: 1,
    ddex_dialog: false,
    ddex_upc: 0,
    ddex: {
      id: null,
      release_title: null,
      format: null,
      artist: null,
      album: null,
      record_label: null,
      asset_label: null,
      isrc: null,
      upc_ean: null,
      language: null,
      genre: null,
      c_line_year: null,
      c_line_text: null,
      p_line_year: null,
      p_line_text: null,
      release_date: null,
      policy: null,
      contributor_roles: []
    },
    ddex_languages: [],
    ddex_roles: [],
    ddex_genres: [],
    ddex_artists: [],
    ddex_asset_labels: [],
    acr_cloud_data_dialog: false
  },

  mutations: {
    setData(state, payload) {
      state.data = payload
    },
    setTrack(state, payload) {
      state.track = payload
      if (state.track.timing_start)
        state.track.timing = [payload.timing_start, payload.timing_end]
    },
    setTiming(state, payload) {
      state.track.timing = [payload.date_start, payload.date_end]
      state.track.timing_start = payload.date_start
      state.track.timing_end = payload.date_end
    },
    setDialogTrack(state, payload) {
      state.dialog_track = payload
    },
    setDialogDDEX(state, payload) {
      state.ddex_dialog = payload
    },
    setDialogArtist(state, { status, type, id }) {
      state.dialog_artist = status
      state.dialog_artist_id = id
      state.dialog_artist_type = type
    },
    setDialogUpload(state, payload) {
      state.dialog_upload = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setUploadImage(state, payload) {
      state.upload_image = payload
    },
    setArtists(state, payload) {
      state.artists = payload
    },
    setGenres(state, payload) {
      state.genres = payload
    },
    setMoods(state, payload) {
      state.moods = payload
    },
    setRestrictions(state, payload) {
      state.restrictions = payload
    },
    setTrackRestrictions(state, payload) {
      state.track.restrictions = payload
    },
    setTrackSmartLinks(state, payload) {
      state.track.smartLinks = payload
    },
    setSocials(state, payload) {
      state.socials = payload.filter(social => {
        return ['YouTube', 'TikTok', 'YouTube Short', 'Instagram'].includes(social.name)
      })
    },
    setImage(state, payload) {
      state.image = payload
    },
    setDownloadTrack(state, payload) {
      state.download_track = payload
    },
    setPricing(state, payload) {
      state.pricing = payload
    },
    setCountries(state, countries) {
      state.countries = countries
    },
    setCountryModal(state, bool) {
      state.countryModal = bool
    },
    setDDEXLanguages(state, payload) {
      state.ddex_languages = payload
    },
    setDDEXRoles(state, payload) {
      state.ddex_roles = payload
    },
    setDDEXGenres(state, payload) {
      state.ddex_genres = payload
    },
    setDDEXUpc(state, payload) {
      state.ddex_upc = payload
    },
    setDDEXArtists(state, payload) {
      state.ddex_artists = payload
    },
    setDDEXAssetLabels(state, payload) {
      state.ddex_asset_labels = payload
    },
    setDDEX(state, payload) {
      state.ddex = payload
    },
    setAcrCloudDataDialog(state, bool) {
      state.acr_cloud_data_dialog = bool
    }
  },

  actions: {
    read({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('import')
        .then(r => {
          commit('setData', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readAdmin({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('import/admin')
        .then(r => {
          commit('setData', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    generate({ dispatch, commit }, id = null) {
      let track_id = id ? [id] : id
      commit('setLoading', true)
      axios.admin
        .post('import/generate', { tracks: track_id }, { timeout: 60000 })
        .then(() => {
          Message({
            type: 'success',
            message: 'Generate completed'
          })
          dispatch('read')
        })
        .catch(e => {
          commit('setLoading', false)
          Message({
            type: 'error',
            message: 'Generate failed:' + e
          })
        })
    },

    userPublish({ dispatch, commit }, id = null) {
      let track_id = id ? [id] : id
      commit('setLoading', true)
      axios.admin
        .post('import/user-publish', {
          tracks: track_id
        })
        .then(() => {
          Message({
            type: 'success',
            message: 'Publish completed'
          })
          dispatch('read')
        })
        .catch(e => {
          commit('setLoading', false)
          Message({
            type: 'error',
            message: 'Publish failed:' + e
          })
        })
    },

    adminPublish({ dispatch, commit }, id = null) {
      let track_id = id ? [id] : id
      commit('setLoading', true)
      axios.admin
        .post('import/admin/publish', {
          tracks: track_id
        })
        .then(() => {
          Message({
            type: 'success',
            message: 'Publish completed'
          })
          dispatch('readAdmin')
        })
        .catch(e => {
          commit('setLoading', false)
          Message({
            type: 'error',
            message: 'Publish failed:' + e
          })
        })
    },

    update({ commit, dispatch, state }, {id, page}) {
      axios.admin
        .post('import/add-meta', {
          id: id,
          track_id: id,
          title: state.track.title,
          artist_id: state.track.artist_id,
          timing: state.track.timing,
          moods: state.track.moods,
          genres: state.track.genres,
          bpm: state.track.bpm,
          ffm_link: state.track.ffm_link,
          restrictions: state.track.restrictions,
          description: state.track.description,
          card_bar_desc: state.track.card_bar_desc,
          smartLinks: state.track.smartLinks,
          platforms: state.track.platforms,
          type: state.track.type,
          nft_description: state.track.nft_description,
          tiktok_pricing:state.track.tiktok_pricing,
          short_pricing:state.track.short_pricing,
          image_url:  state.track.image_url,
          short_challenge: state.track.short_challenge,
          tiktok_challenge: state.track.tiktok_challenge,
          instagram_challenge: state.track.instagram_challenge,
          regular_challenge: state.track.regular_challenge,
          image:  state.image,
          isrc: state.track.isrc,
          delivered: state.track.delivered,
          album: state.track.album,
          record_label: state.track.record_label
        })
        .then(() => {
          commit('setDialogTrack', false)

          if (page == 'user') {
            dispatch('read')
          } else if (page == 'admin'){
            dispatch('readAdmin')
          }
        })
    },

    deleteTrack({ dispatch }, id) {
      axios.admin
        .post('import/delete', {
          track_id: id
        })
        .then(() => {
          dispatch('read')
        })
    },

    deleteTrackAdmin({ dispatch }, id) {
      axios.admin
        .post('import/delete', {
          track_id: id
        })
        .then(() => {
          dispatch('readAdmin')
        })
    },

    uploadImage({ dispatch, commit }, image) {
      axios.admin.post('import/image', image).then(r => {
        dispatch('read')
        commit('setUploadImage', r.data.response.message)
      })
    },

    readArtist({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('import/artist')
        .then(r => {
          commit('setArtists', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    async downloadTrack({ commit, dispatch }, id) {
      try {
        const ids = Array.isArray(id) ? id.join(',') : id
        const response = await axios.admin.get(`import/download-track/${ids}`, {
          responseType: "arraybuffer",
        })

        if (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          const fileName = await dispatch('filename', id)
          if (fileName) {
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
            commit('setDownloadTrack', null)
          }
        }
      } catch (e) {
        console.log(e)
      }
    },

    async filename({ state }, ids) {
      if (Array.isArray(ids)) if (ids.length > 1) return 'tracks.zip'
      const trackId = Array.isArray(ids) ? ids[0] : ids

      const findTrack = state.data.find(_ => _.id === trackId)

      if (findTrack) return findTrack.original_file_name
      return 'track.mp3'
    },

    async setApproveStatus({ dispatch }, track) {
      try {
        const response = await axios.admin.post(`import/${track.id}/${track.approved}`)

        if (response) dispatch('read')
      } catch (e) {
        console.log(e)
      }
    },

    async getCountries({ commit }) {
      try {
        const response = await axios.defaultUrl.get('countries?continents=1')

        if (response) commit('setCountries', response.data.data)
      } catch (e) {
        console.log(e)
      }
    },

    async analyzeTrack({ dispatch }, track) {
      try {
        const confirm = await MessageBox.confirm(
            'Please confirm that you want to perform analysis for this track'
        )
        if (confirm) {
          const response = await axios.admin.post(`import/analyze`, {
            trackId: track.id
          })
          if (response) dispatch('read')
        }
      } catch (e) { console.log(e) }
    },

    async allow({ dispatch }, trackId) {
      try {
        const confirm = await MessageBox.confirm(
            'Please confirm that you want to allow this track'
        )
        if (confirm) {
          const response = await axios.admin.put(`import/allow/${trackId}`)
          if (response) dispatch('read')
        }
      } catch (e) { console.log(e) }
    },

    readDDEXLanguages({ commit }) {
      commit('setLoading', true)
      axios.admin
          .get('ddex/languages')
          .then(r => {
            commit('setDDEXLanguages', r.data.languages)
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },

    readDDEXRoles({ commit }) {
      commit('setLoading', true)
      axios.admin
          .get('ddex/roles')
          .then(r => {
            commit('setDDEXRoles', r.data.roles)
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },

    readDDEXGenres({ commit }) {
      commit('setLoading', true)
      axios.admin
          .get('ddex/genres')
          .then(r => {
            commit('setDDEXGenres', r.data.genres)
            commit('setLoading', false)

          })
          .catch(() => {
            commit('setLoading', false)
          })
    },

    async getDDEXUpc({ commit }) {
      try {
        const response = await axios.admin.get('ddex/upc')

        if (response) commit('setDDEXUpc', response.data.upc)
      } catch (e) {
        console.log(e)
      }
    },

    readDDEXArtists({ commit }) {
      commit('setLoading', true)
      axios.admin
          .get('ddex/artists')
          .then(r => {
            commit('setDDEXArtists', r.data.artists)
            commit('setLoading', false)

          })
          .catch(() => {
            commit('setLoading', false)
          })
    },

    readDDEXAssetLabels({ commit }) {
      commit('setLoading', true)
      axios.admin
          .get('ddex/asset-labels')
          .then(r => {
            commit('setDDEXAssetLabels', r.data.asset_labels)
            commit('setLoading', false)

          })
          .catch(() => {
            commit('setLoading', false)
          })
    },

    generateDDEX({ commit, state }) {
      commit('setLoading', true)
      axios.admin
          .post('ddex/generate', {
            id: state.ddex.id,
            cid_release_title: state.ddex.release_title,
            cid_format: state.ddex.format,
            artist: state.ddex.artist,
            album: state.ddex.album,
            record_label: state.ddex.record_label,
            cid_asset_label: state.ddex.asset_label,
            isrc: state.ddex.isrc,
            cid_upc_ean: state.ddex.upc_ean,
            cid_language: state.ddex.language,
            genre: state.ddex.genre,
            cid_c_line_year: state.ddex.c_line_year,
            cid_c_line_text: state.ddex.c_line_text,
            cid_p_line_year: state.ddex.p_line_year,
            cid_p_line_text: state.ddex.p_line_text,
            cid_release_date: state.ddex.release_date,
            cid_policy: state.ddex.policy,
            contributor_roles: state.ddex.contributor_roles
          })
          .then(r => {
            commit('setLoading', false)

          })
          .catch(() => {
            commit('setLoading', false)
          })
    },

  },

  getters: {}
}
